import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { translate } from "../Services/translation";
import {
    setQuery,
    search,
    remove,
    clearArticleList,
    setQuantity,
} from "../Actions/DropZone.action";
import {
    clear as clearCart,
    addMany as addManyToCart,
} from "../Actions/Cart.action";

class DropZoneContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { ...props };
    }

    componentDidMount() {
        if (!this.props || !this.props.dropZone) {
            return;
        }
    }
    componentDidUpdate() {
        const { dropZone } = this.props;
        if (!dropZone.errors) {
            return;
        }
    }

    removeArticle(id) {
        this.props.remove(id);
    }

    searchArticle(mobile) {
        this.props.search(mobile);
        this.clearDropZone();
    }

    keyDown(event, mobile) {
        switch (event.keyCode) {
            case 13:
                this.props.search(mobile);
                this.clearDropZone();
                event.preventDefault();
                break;
            default:
                break;
        }
    }

    clearDropZone() {
        this.setState({queryArticleQuantities: ""});
        this.setState({ queryArticleNumbers: ""});
    }

    addArticlesToCart(event) {
        const articles = Object.keys(this.props.dropZone.articles).map(
            (key) => this.props.dropZone.articles[key]
        );
        const addToCartObjectArray = [];
        for (var i = 0; i < articles.length; i++) {
            if (articles[i].buyable > 3 && articles[i].quantity !== "-") {
                addToCartObjectArray.push({
                    articleNumber: articles[i].id,
                    quantity: articles[i].inStockQuantity < articles[i].quantity ? articles[i].inStockQuantity : articles[i].quantity,
                });
            }
        }

        if (addToCartObjectArray.length > 0) {
            const nonBuyableArticles = articles.filter(x => x.inStockQuantity < x.quantity);
            if (nonBuyableArticles != null && nonBuyableArticles.length > 0) {
                this.setState({
                    dropZone: {
                        ...this.props.dropZone,
                        nonBuyableArticles: nonBuyableArticles,
                    }
                });
                dropZoneInfoModal.showModal();
            } else {
                this.props.addManyToCart(event.target, addToCartObjectArray);
                setTimeout(() => {
                    this.setState({ dropZone: { query: "", showInfo: false } });
                    this.props.clearArticleList();
                }, 700);
            }
        }
    }

    handleApprove(event) {
        const articles = Object.keys(this.props.dropZone.articles).map(
            (key) => this.props.dropZone.articles[key]
        );
        const addToCartObjectArray = [];
        for (var i = 0; i < articles.length; i++) {
            if (articles[i].buyable > 3 && articles[i].quantity !== "-") {
                addToCartObjectArray.push({
                    articleNumber: articles[i].id,
                    quantity: articles[i].inStockQuantity < articles[i].quantity ? articles[i].inStockQuantity : articles[i].quantity,
                });
            }
        }
        if (addToCartObjectArray.length > 0) {
            this.props.addManyToCart(event.target, addToCartObjectArray);
            dropZoneInfoModal.close();
            setTimeout(() => {
                this.setState({ dropZone: { query: "", showInfo: false } });
                this.props.clearArticleList();
            },
                700);
        }
    }
    resetCart(event) {
        if (confirm(translate("common.dropzone.cartwarning"))) {
            this.props.clearCart(event.target);
        }
    }

    querySet(query) {
        this.setState({
            dropZone: { ...this.props.dropZone, query: query, showInfo: true },
        });
        this.props.setQuery(query);
    }

    setArticleNumbers(articleNumbers) {
        this.setState({
            queryArticleNumbers: articleNumbers
        });
    }

    setArticleQuantities(articleQuantities) {
        this.setState({
            queryArticleQuantities: articleQuantities
        });
    }

    addArticlesAndQuantity(event) {
        const articleNumbers = this.state.queryArticleNumbers;
        const articleQuantities = this.state.queryArticleQuantities;

        if (articleNumbers && articleQuantities) {
            const articleNumberList = articleNumbers
                .toUpperCase()
                .split(/[ :;?!~,`"&|()<>{}\[\]\r\n\t/"'\\]+/)
                .map(x => ({ articleNumber: x.trim() }));
            const articleQuantityList = articleQuantities
                .split(/[ :;?!~,`"&|()<>{}\[\]\r\n\t/"'\\]+/)
                .map(x => ({ quantity: parseInt(x.trim()) }));

            if (articleNumberList.length != articleQuantityList.length) {
                confirm(translate('common.dropzone.mismatch.error'));
                this.clearDropZone();
                return;
            }
            let completeDropZoneQuery = articleNumberList.map((item, i) => Object.assign({}, item, articleQuantityList[i]));
            this.querySet(completeDropZoneQuery);
            this.props.search(false);
            this.clearDropZone();
            event.preventDefault();
        } else {
            confirm(translate('common.dropzone.mismatch.error'));
            this.clearDropZone();
            return;
        }
    }

    toggle() {
        this.setState({
            dropZone: {
                ...this.props.dropZone,
                showInfo: !this.state.dropZone.showInfo,
            },
        });
    }

    setDropzoneFocus(event) {
        if (event.keyCode === 13) {
            if (this.props.mobile) {
                document
                    .getElementsByClassName("dropzone-input-mobile")[0]
                    .focus();
            } else {
                document
                    .getElementsByClassName("dropzone-input-desktop")[0]
                    .focus();
            }

            event.preventDefault();
        }
    }

    render() {
        const articles = Object.keys(this.props.dropZone.articles).map(
            (key) => this.props.dropZone.articles[key]
        );
        var showClearCartButton = false;
        var cartQuantity = document.getElementsByClassName("cart__quantity");
        if (cartQuantity.length > 0) {
            showClearCartButton = cartQuantity[0].innerHTML !== "0";
        }
        let strokeColor = '#00a0d6'
        if (document.body.classList.contains("org-eon")) {
            strokeColor = '#888';
        }
        if (document.body.classList.contains("org-telenor")) {
            strokeColor = '#00ACE7';
        }

        return (
            <Fragment>
                <div
                    className="top-link__title dropzone__toplink"
                    onClick={() => this.toggle()}>
                    <svg
                        xmlns="http://www.w3.org/1999/xlink"
                        className="idropzone"
                        viewBox="0 0 448 512">
                        <path
                            d="M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
                            fill="#ffff"
                            stroke={strokeColor}
                            strokeWidth={20}
                        />
                    </svg>
                </div>
                <div
                    className={`dropzone ${!this.state.dropZone.showInfo ? "dropzone--hidden" : ""
                        }`}>
                    <div
                        className="close-button"
                        onClick={() => this.toggle()}></div>
                    <textarea
                        className="dropzone__input dropzone__input--artnr dropzone-input-desktop"
                        placeholder={translate("common.dropzone.search")}
                        autoComplete="off"
                        value={this.state.queryArticleNumbers}
                        onChange={(event) => this.setArticleNumbers(event.target.value)
                        }></textarea>
                    <textarea
                        className="dropzone__input dropzone__input--quantity dropzone-input-desktop"
                        placeholder={translate("common.dropzone.search.quantity")}
                        autoComplete="off"
                        value={this.state.queryArticleQuantities}
                        onChange={(event) => this.setArticleQuantities(event.target.value)
                        }></textarea>

                    {articles &&
                        articles.map((article) => (
                            <div key={article.id} className="articles-wrapper">
                                <label className="dropzone__name">
                                    {article.name}
                                </label>
                                <div>
                                    <input
                                        className={
                                            "art-no " +
                                            article.searchResultCssClass
                                        }
                                        type="text"
                                        value={article.id}
                                        readOnly
                                    />
                                    <input
                                        className="dropzone-quantity dropzone-quantity-desktop"
                                        type="text"
                                        value={
                                            article.name === "-"
                                                ? "-"
                                                : article.quantity
                                        }
                                        onChange={(event) =>
                                            this.props.setQuantity(
                                                article.id,
                                                parseInt(event.target.value)
                                            )
                                        }
                                        onKeyDown={(event) =>
                                            this.setDropzoneFocus(event)
                                        }
                                    />
                                    <div className="stockStatus">
                                        <span
                                            className={
                                                "dropzone__instock dropzone__instock--" +
                                                article.stockStatusCssClass
                                            }></span>
                                    </div>
                                    <div className="removeButton">
                                        <button
                                            onClick={() =>
                                                this.removeArticle(
                                                    article.id
                                                )
                                            }>
                                            <i
                                                className="fa fa-trash"
                                                aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}

                    <div className="dropzone__buttons">
                        <button
                            className="button dropzone__button dropzone__addarticles-button"
                            type="button"
                            onClick={(event) => this.addArticlesAndQuantity(event)}>
                            <span className="dropzone__cart-cleararticles-title">
                                {translate("common.dropzone.addarticles")}
                            </span>
                        </button>
                        <button
                            className="button dropzone__button dropzone__cleararticles-button"
                            type="button"
                            onClick={(event) =>
                                this.props.clearArticleList(event)
                            }>
                            <span className="dropzone__cart-cleararticles-title">
                                {translate("common.dropzone.cleararticles")}
                            </span>
                        </button>
                        <button
                            className="button dropzone__button dropzone__cart-button"
                            type="button"
                            onClick={(event) => this.addArticlesToCart(event)}>
                            <span className="dropzone__cart-button-title">
                                {translate("common.dropzone.addtocart")}
                            </span>
                        </button>
                        {showClearCartButton && (
                            <button
                                className="button dropzone__button dropzone__clearcart-button"
                                type="button"
                                onClick={(event) => this.resetCart(event)}>
                                <span className="dropzone__clearcart-button-title">
                                    {translate("common.dropzone.clearcart")}
                                </span>
                            </button>
                        )}
                    </div>
                </div>
                <dialog id="dropZoneInfoModal" className="dropzone-modal">
                    <form method="dialog">
                        <div className="dropzone-modal__wrapper">
                            <div className="close-button" onClick={() => dropZoneInfoModal.close()}></div>
                            <h3>{translate('common.dropzone.modal.title')}</h3>
                            <div className="dropzone-modal__info-container">
                                {this.state.dropZone.nonBuyableArticles && this.state.dropZone.nonBuyableArticles.map((article) => {
                                    return (
                                        <div className="dropzone-modal__article-info">
                                            <div>{translate('common.dropzone.modal.article.name')}:<strong> {article.name}</strong></div>
                                            <div>{translate('common.dropzone.modal.article.quantity')}:<strong> {article.quantity}</strong></div>
                                            <div>{translate('common.dropzone.modal.article.instock.quantity')}:<strong> {article.inStockQuantity}</strong></div>
                                        </div>
                                    );
                                })}
                            </div>
                            <h3>{translate('common.dropzone.modal.info')}</h3>
                            <div className="dropzone-modal__button-container small-12 columns">
                                <button
                                    className="button dropzone-modal__button dropzone-modal__button--approve"
                                    type="button"
                                    onClick={(event) => this.handleApprove(event)}>
                                    <span className="dropzone__cart-button-title">
                                        {translate('common.dropzone.modal.approve')}
                                    </span>
                                </button>
                                <button
                                    className="button dropzone-modal__button dropzone-modal__button--cancel"
                                    type="button"
                                    onClick={(event) => dropZoneInfoModal.close()}>
                                    <span className="dropzone__cart-button-title">
                                        {translate('common.dropzone.modal.cancel')}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </form>
                </dialog>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { dropZone } = state;
    return {
        dropZone,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setQuery: (text) => dispatch(setQuery(text)),
        setQuantity: (id, q) => dispatch(setQuantity(id, q)),
        search: (mobile) => dispatch(search(mobile)),
        clearArticleList: () => dispatch(clearArticleList()),
        remove: (id) => dispatch(remove(id)),
        onKeyDown: (event, opt) => dispatch(handleKeyDown(event, opt)),
        addManyToCart: (buttonDomNode, articles) => {
            const nodeIdToShowNotification = (buttonDomNode.id = Date.now());
            dispatch(
                addManyToCart({
                    articles,
                    nodeIdToShowNotification,
                    notificationMessage: translate("tooltip.addedmanytocart"),
                    hash: Date.now(),
                })
            );
        },
        addManyToFavourites: (articles) => {
            dispatch(addManyToFavourites(articles));
        },
        clearCart: (buttonDomNode) => {
            const nodeIdToShowNotification = (buttonDomNode.id = Date.now());
            dispatch(
                clearCart({
                    nodeIdToShowNotification,
                    notificationMessage: translate("tooltip.clearcart"),
                    hash: Date.now(),
                })
            );
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DropZoneContainer);